document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("vastu-expert-btn");
  const popup = document.getElementById("vastu-popup");
  const close = document.querySelector(".vastu-close");

  if (btn && popup) {
    btn.addEventListener("click", function () {
      popup.style.display =
        popup.style.display === "block" ? "none" : "block";
    });
  }

  if (close) {
    close.addEventListener("click", function () {
      popup.style.display = "none";
    });
  }
});